import { Box, Colors, Text } from '@factorialco/deprecated-design-system'

import { NpsWidgetVariant } from 'modules/nps/lib/types'

type ColorConfig = {
  backgroundColor: Colors
  textColor: Colors
}

type OptionProps = {
  value: number
  onClick: (score: number | undefined) => void
  isSelected: boolean
  isLarge: boolean
  variant: NpsWidgetVariant
}

const getColorConfig = (variant: NpsWidgetVariant): ColorConfig => {
  switch (variant) {
    case 'champagne':
      return { textColor: 'champagne1200', backgroundColor: 'champagne200' }
    case 'radical':
      return { textColor: 'radicalRed1200', backgroundColor: 'radicalRed200' }
    case 'tangerine':
      return { textColor: 'tangerine1000', backgroundColor: 'tangerine200' }
    case 'viridian':
    default:
      return { textColor: 'viridian1200', backgroundColor: 'viridian200' }
  }
}

const _Option = ({ value, onClick, isSelected, isLarge, variant }: OptionProps) => {
  const size = isLarge ? '72px' : '56px'
  const dimensions = { height: size, width: size }
  const colorConfig = getColorConfig(variant)

  return (
    <Box
      cursor="pointer"
      onClick={(_) => onClick(value)}
      style={dimensions}
      borderRadius={{ all: 'abs008' }}
      background={isSelected ? colorConfig.backgroundColor : 'white'}
      border={{
        all: {
          color: isSelected ? colorConfig.textColor : 'grey400',
          style: 'solid',
          width: isSelected ? 's2' : 's1',
        },
      }}
      justifyContent="center"
      alignItems="center"
    >
      <Text
        size={isLarge ? '500' : '400'}
        weight="medium"
        color={isSelected ? colorConfig.textColor : 'grey1000'}
      >
        {value}
      </Text>
    </Box>
  )
}

export default _Option
